import { Reveal, Overline } from "./Reveal";

export default function About({ about }) {
  return (
    <section id="nosotros" className="relative py-28 sm:py-36" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <Overline>{about.overline}</Overline>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display font-medium tracking-tight text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
                {about.title}
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal delay={0.15}>
              <p className="text-lg sm:text-xl leading-relaxed text-white/70">{about.body}</p>
            </Reveal>

            <div className="mt-14 grid grid-cols-3 gap-6 border-t border-white/10 pt-10">
              {(about.stats || []).map((s, i) => (
                <Reveal key={i} delay={0.2 + i * 0.1}>
                  <div>
                    <div className="font-display text-4xl sm:text-5xl text-jauja-lime">{s.value}</div>
                    <div className="mt-2 text-xs sm:text-sm text-white/50 leading-snug">{s.label}</div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
